import type {
  ContentObject,
  ContentObjectReference,
} from '../../../lib/flotiq-client/types/api-response';

import { useMemo } from 'react';

import { EMPTY_ARRAY } from '../../../lib/globals';

import RelationCard from '../../../components/RelationCard/RelationCard';

import useApiErrorsToast from '../../api/useApiErrorsToast';
import { useFeaturedImages } from '../../api/useFeaturedImages';
import { useRelations } from '../../api/useRelations';

const RELATION_HOOK_PARAMS = { limit: 1000, page: 1 };

interface CascadeModalContentProps {
  /**
   * Object references
   */
  references?: ContentObjectReference[];
  /**
   * Test id for the component
   */
  testId?: string;
}

const CascadeModalContent = ({
  references = EMPTY_ARRAY,
  testId,
}: CascadeModalContentProps) => {
  const { data, isLoading, isFetching, errors } = useRelations(
    references,
    RELATION_HOOK_PARAMS,
  );

  useApiErrorsToast(errors);

  const contentTypes = useMemo(
    () =>
      isLoading || !data
        ? []
        : Object.values(data).map(({ contentType }) => contentType),
    [data, isLoading],
  );

  const [featuredImages, featuredImagesLoading] =
    useFeaturedImages(contentTypes);

  return (
    <div className="flex flex-col items-center space-y-2 mb-24 xs:mb-0">
      {Object.entries(data || {}).map(([contentTypeName, relation]) => {
        const relationType = contentTypeName;
        const objects = relation.data ? relation.data : relation;
        const titleField = relation.titleField;

        return objects.map((relation: string | ContentObject) => {
          const relationData =
            typeof relation === 'string' ? { id: relation } : relation;

          return (
            <RelationCard
              key={`${relationType}-${relationData.id}`}
              relation={relationData}
              relationType={relationType}
              featuredImageUrl={featuredImages[contentTypeName]}
              featuredImageLoading={featuredImagesLoading}
              titleField={titleField}
              relationsAreLoading={isFetching}
              withObjectStatus
              testId={testId}
            />
          );
        });
      })}
    </div>
  );
};

export default CascadeModalContent;
